import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  getAllPageIDList,
  postUploadJSONPageDetailsAPI,
} from 'features/Account/services/adminAccessPageID'
import { QueryURLPageIDListType } from 'features/Account/@types/adminAccessPageIDList'
import { toastSuccess } from 'utils/toast'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  SLICE_NAME,
  setAdminAccessPageIDList,
  setLoadingList,
  setAdminURLQuery,
  setIsUploadingJSON,
  toggleDialogUploadJSON,
  initialState,
} from './adminAccessPageIDSlice'

export const onGetAllPageIDList = createAsyncThunk<
  void,
  { query?: QueryURLPageIDListType | undefined; isVendor: boolean }
>(`${SLICE_NAME}/getAllPageIDList`, async ({ query, isVendor }, { dispatch, getState }) => {
  const {
    adminAccessPageID: { queryURL },
  } = getState() as StoreStateType
  const newQuery = { ...queryURL, ...query }
  dispatch(setAdminURLQuery(newQuery))
  try {
    dispatch(setLoadingList(true))
    const response = await getAllPageIDList(newQuery, isVendor)
    dispatch(setAdminAccessPageIDList(response.data.data))
  } catch (error) {
    callErrorMsg(error)
  } finally {
    dispatch(setLoadingList(false))
  }
})

export const postCreatePageIDbyJSON = createAsyncThunk<
  void,
  { jsonString: string; isVendor: boolean }
>(`${SLICE_NAME}/postCreatePageIDbyJSON`, async ({ isVendor, jsonString }, { dispatch }) => {
  try {
    dispatch(setIsUploadingJSON(true))
    const payload = { page_json: jsonString }
    await postUploadJSONPageDetailsAPI(payload, isVendor)
    toastSuccess('Berhasil mengupload json page')
    dispatch(toggleDialogUploadJSON('CLOSED'))
    dispatch(onGetAllPageIDList({ query: initialState.queryURL, isVendor }))
  } catch (error) {
    callErrorMsg(error)
  } finally {
    dispatch(setIsUploadingJSON(false))
  }
})
